import { render, staticRenderFns } from "./PsCardHeader.vue?vue&type=template&id=122df95a&scoped=true&"
import script from "./PsCardHeader.vue?vue&type=script&lang=js&"
export * from "./PsCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./PsCardHeader.vue?vue&type=style&index=0&id=122df95a&scoped=true&lang=scss&"
import style1 from "./PsCardHeader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122df95a",
  null
  
)

component.options.__file = "PsCardHeader.vue"
export default component.exports